<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { useField } from 'vee-validate'
import { useRoute, useRouter } from 'vue-router'
import { KkLoading, KkRadioGroup, KkButton, KkBox } from '../../../components/base'
import { KkInfo } from '../../../components/ui'
const store = useStore()
const router = useRouter()
const { t } = useI18n()
const { company_uuid } = useRoute().params
const company = computed(() => store.state.companiesCompany.data)
const companyLoading = computed(() => store.state.companiesCompany.loading)
const updateSnsApprovalFlowLoading = computed(() => store.state.companiesSnsApprovalFlows.loading)
const readCompanies = () => store.dispatch('companiesCompany/readCompany', company_uuid)
const updateSnsApprovalFlow = (payload) => store.dispatch('companiesSnsApprovalFlows/updateApprovalFlow', payload)
const readRequestingPosts = () => store.dispatch('companiesStoreSnsPosts/readRequestingPosts', {})
const requestingPosts = computed(() => store.getters['companiesStoreSnsPosts/posts'])
const snsPostsLoading = computed(() => store.getters['companiesStoreSnsPosts/postLoading'])
const { value: approvalFlow, handleChange: approvalFlowHandleChange } = useField('approvalFlow', undefined, { initialValue: 'off' })
const approvalFlowOptions = [
  {
    id: 'on',
    value: 'on',
    text: t('pages.companies.snsApprovalFlowForm.on'),
  },
  {
    id: 'off',
    value: 'off',
    text: t('pages.companies.snsApprovalFlowForm.off'),
  },
]
const onSubmit = async () => {
  if (approvalFlow.value === 'off' && requestingPosts.value.length !== 0) {
    alert(t('pages.companies.postApprovalFlowForm.invalidAlert'))
    return
  }
  const isSuccess = await updateSnsApprovalFlow({ sns_approval_flow: approvalFlow.value === 'on' })
  if(isSuccess) router.push({ name: 'CompaniesManagement', params: { company_uuid: company_uuid } })
}
const load = async () => {
  await readCompanies()
  if(company.value.attributes.sns_approval_flow) readRequestingPosts()
  approvalFlow.value = company.value.attributes.sns_approval_flow ? 'on' : 'off'
}
load()
</script>
<template>
  <KkBox>
    <template #content>
      <div class="p-box__body">
        <div class="p-box">
          <div class="p-box__header">
            <p class="p-box__title">
              {{ $t('pages.companies.snsApprovalFlowForm.header') }}
            </p>
          </div>
          <div class="p-box__body">
            <KkInfo>
              {{ $t('pages.companies.snsApprovalFlowForm.info') }}
            </KkInfo>
            <KkLoading v-if="companyLoading || updateSnsApprovalFlowLoading || snsPostsLoading" />
            <div v-else class="form">
              <KkRadioGroup
                :model-value="approvalFlow"
                :items="approvalFlowOptions"
                class="c-radio__input"
                :name="$t('pages.companies.mapionBizSearchGroupsForm.basicSetting.conditionType.label')"
                @update:model-value="approvalFlowHandleChange"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="buttons">
        <div class="buttonWrapper">
          <KkButton
            color="secondary"
            :to="{ name: 'CompaniesManagement', params: { company_uuid: company_uuid } }"
            :text="$t('labels.cancel')"
          />
        </div>
        <div class="buttonWrapper">
          <KkButton
            color="primary"
            :text="$t('labels.save')"
            @click="onSubmit()"
          />
        </div>
      </div>
    </template>
  </KkBox>
</template>
<style lang="scss" scoped>
.buttons {
  margin-top: 32px;
  display: flex;
  justify-content: flex-end;
}
.buttonWrapper:not(:first-child) {
  margin-left: 8px;
}
.form {
  margin-top: 10px;
}
</style>
